import React from "react";


export default function CTABanner({text, ctaURL, ctaString}) {

    return (
        <div
            className="elementor-element elementor-element-f1228cf e-flex e-con-boxed e-con e-parent elementor-kit-159 elementor"
            data-id="f1228cf"
            data-element_type="container"
        >
            <div className="e-con-inner ">
                <div
                    className="elementor-element elementor-element-f406ec5 elementor-widget elementor-widget-template "
                    data-id="f406ec5"
                    data-element_type="widget"
                    data-widget_type="template.default"
                >
                    <div className="elementor-widget-container">
                        <div className="elementor-template">
                            <div
                                data-elementor-type="container"
                                data-elementor-id={1770}
                                className="elementor elementor-1770"
                                data-elementor-post-type="elementor_library"
                            >
                                <div
                                    className="elementor-element elementor-element-43c693e0 e-flex e-con-boxed e-con e-parent points-section"
                                    data-id="43c693e0"
                                    data-element_type="container"
                                    data-settings='{"background_background":"classic"}'
                                >
                                    <div className="e-con-inner">
                                        <div
                                            className="elementor-element elementor-element-75867125 elementor-widget__width-initial elementor-widget elementor-widget-heading"
                                            data-id={75867125}
                                            data-element_type="widget"
                                            data-widget_type="heading.default"
                                        >
                                            <div className="elementor-widget-container">
                                                <h2 className="elementor-heading-title elementor-size-default">
                                                    {text}
                                                </h2>
                                            </div>
                                        </div>
                                        <div
                                            className="elementor-element elementor-element-58fe34d3 elementor-align-right elementor-mobile-align-justify elementor-widget__width-initial elementor-widget elementor-widget-button"
                                            data-id="58fe34d3"
                                            data-element_type="widget"
                                            data-widget_type="button.default"
                                        >
                                            <div className="elementor-widget-container">
                                                <div className="elementor-button-wrapper">
                                                    <a
                                                        className="elementor-button elementor-button-link elementor-size-sm elementor-animation-shrink"
                                                        href={ctaURL}
                                                        target="_blank"
                                                    >
                                                    <span className="elementor-button-content-wrapper">
                                                      <span className="elementor-button-icon">
                                                        <i aria-hidden="true" className="fas"/>{" "}
                                                      </span>
                                                      <span className="elementor-button-text" style={{color: "#014737"}}>
                                                        {ctaString}
                                                      </span>
                                                    </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}